import { render, staticRenderFns } from "./exchangeCoupon.vue?vue&type=template&id=27bb28cd&scoped=true&"
import script from "./exchangeCoupon.vue?vue&type=script&lang=js&"
export * from "./exchangeCoupon.vue?vue&type=script&lang=js&"
import style0 from "./exchangeCoupon.vue?vue&type=style&index=0&id=27bb28cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb28cd",
  null
  
)

component.options.__file = "exchangeCoupon.vue"
export default component.exports